import _get from 'lodash/get';
import fr   from '@/models/localization/fr.json';

const UI_LABELS = fr.ui;

type Section = Extract<keyof typeof UI_LABELS, string>;

export type UiLabelKey = {
	[S in Section]: `${S}.${Extract<keyof (typeof UI_LABELS)[S], string>}`
}[Section];

export const localizeUi = (key: UiLabelKey) => _get(UI_LABELS, key) as string;
